<template>
  <div class="lh-15 c-333">
    <ProductBanner
      is-fixed
      is-scroll
      :banner-img="bannerImg"
      :product-name="$t('common.productName.3DExcavator')"
      :product-img-style="{ backgroundImage: `url(${bannerProductImg})` }"
      :custom-style="{ bottom: '2.44rem', left: '2rem' }"
      :main-title="'FJD G31'"
      :sub-title="'3D Excavator Guidance System '"
      :slogan="'Higher Efficiency With Reduced Cost'"
    >
    </ProductBanner>
    <div class="content p-r z-3 bgc-fff">
      <NavAnchor :product-name="$t('common.productName.3DExcavator')" :spec-url="'/product/excavatorSpecs'" />
      <IconWrap :icon-wrap-data="iconWrapData" id="overview" />
      <videoWrap :video-index="1" :video-info="videoInfo" :custom-style="{ width: '12rem' }" />
      <section class="area-3" id="features">
        <div class="sticky">
          <h2 class="m-0 ta-c ff-asb c-333">Key Benefits</h2>
          <div
            class="area3-bg p-r ov-h lazy-image"
            data-original="@/assets/images/3d-excavator/area3-bg.jpg"
            data-m-original="@/assets/images/3d-excavator/area3-bg-m.jpg"
          >
            <div class="area-3-content-wrap swiper-wrapper">
              <div class="area3-cont-1 swiper-slide">
                <div class="area3-bg-desc">
                  Digital Construction <br class="in-h5" />vs. <br class="in-h5" />Traditional Construction
                </div>
                <div class="labor-hours-warp">
                  <div class="labor-hours-warp-col">
                    <div class="item-warp d-f ai-c">
                      <img
                        class="arrow-bootom"
                        src="data:image/svg+xml,%3Csvg width='17' height='30' viewBox='0 0 17 30' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M11.333 0v18.45H17L8.5 30 0 18.45h6.044V0h5.29z' id='a'/%3E%3C/defs%3E%3Cuse fill='%23FFF' xlink:href='%23a' fill-rule='evenodd'/%3E%3C/svg%3E"
                        alt=""
                        srcset=""
                      />
                      <span class="num">45%</span>
                    </div>
                    <div class="bottom-desc">Fuel Consumption</div>
                  </div>
                  <div class="labor-hours-warp-col">
                    <div class="item-warp d-f ai-c">
                      <img
                        class="arrow-bootom"
                        src="data:image/svg+xml,%3Csvg width='17' height='30' viewBox='0 0 17 30' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M11.333 0v18.45H17L8.5 30 0 18.45h6.044V0h5.29z' id='a'/%3E%3C/defs%3E%3Cuse fill='%23FFF' xlink:href='%23a' transform='matrix(1 0 0 -1 0 30)' fill-rule='evenodd'/%3E%3C/svg%3E"
                        alt=""
                        srcset=""
                      />
                      <span class="num">150%</span>
                    </div>
                    <div class="bottom-desc">
                      Proportion of Measuring <br />
                      Point Accuracy Within 3cm
                    </div>
                  </div>
                  <div class="labor-hours-warp-col">
                    <div class="item-warp d-f ai-c">
                      <img
                        class="arrow-bootom"
                        src="data:image/svg+xml,%3Csvg width='17' height='30' viewBox='0 0 17 30' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M11.333 0v18.45H17L8.5 30 0 18.45h6.044V0h5.29z' id='a'/%3E%3C/defs%3E%3Cuse fill='%23FFF' xlink:href='%23a' fill-rule='evenodd'/%3E%3C/svg%3E"
                        alt=""
                        srcset=""
                      />
                      <span class="num">35%</span>
                    </div>
                    <div class="bottom-desc">Labor Hours</div>
                  </div>
                </div>
              </div>
              <div class="area3-cont-2 swiper-slide">
                <div class="area3-bg-desc2 ta-c">
                  Using FJD G31 3D excavator guidance system simplifies the repetitive steps of lofting,
                  <br class="in-pc" />
                  piling and measuring in traditional construction, making construction easier and more efficient.
                </div>
                <div class="area3-bg-icon">
                  <ul class="ta-c d-f">
                    <li>
                      <i
                        ><img
                          src="data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h64v64H0z'/%3E%3Cpath d='M10 14.806L32 8l22 6.806v12.356C54 40.7 54 48.832 32.003 57 10 48.833 10 40.698 10 27.156v-12.35z' stroke='%23FFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M39.466 32.42c0 .949-.133 1.842-.4 2.68a7.59 7.59 0 0 1-1.149 2.26l2.73 2.716-2.057 1.841-2.742-2.704a7.321 7.321 0 0 1-1.892.787 8.42 8.42 0 0 1-2.145.267c-2.21 0-4.008-.743-5.396-2.228-1.388-1.486-2.082-3.358-2.082-5.618v-3.326c0-2.252.692-4.122 2.076-5.612 1.383-1.49 3.184-2.234 5.402-2.234 2.26 0 4.1.745 5.522 2.234 1.422 1.49 2.133 3.36 2.133 5.612v3.326zm-3.085-3.35c0-1.541-.41-2.806-1.232-3.797-.82-.99-1.934-1.485-3.338-1.485-1.363 0-2.436.495-3.219 1.485-.783.99-1.174 2.256-1.174 3.796v3.352c0 1.557.394 2.833 1.18 3.828.788.994 1.858 1.491 3.213 1.491 1.413 0 2.528-.495 3.345-1.485.816-.99 1.225-2.268 1.225-3.834v-3.352z' fill='%23FFF' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E"
                          width="100%"
                          height="100%"
                          alt="High Quality"
                      /></i>
                      <span>High Quality</span>
                    </li>
                    <li>
                      <i
                        ><img
                          src="data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cpath stroke-linejoin='round' d='M9.5 20.75h35v22.5h-35z'/%3E%3Cpath d='M22.625 44.5v6.25m8.75-6.25v6.25M18.875 52h16.25M32 20.75V14.5c0-.69.56-1.25 1.25-1.25h20c.69 0 1.25.56 1.25 1.25v36.25c0 .69-.56 1.25-1.25 1.25H40' stroke-linecap='round'/%3E%3C/g%3E%3C/svg%3E"
                          width="100%"
                          height="100%"
                          alt="Easy to Use"
                      /></i>
                      <span>Easy to Use</span>
                    </li>
                    <li>
                      <i
                        ><img
                          src="data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h64v64H0z'/%3E%3Cg transform='translate(10.667 7.333)' stroke='%23FFF' stroke-width='2'%3E%3Cpath d='M28.95 46.378H8.063C3.61 46.378 0 42.783 0 38.348c0-.425.034-.849.101-1.268l1.549-9.652c1.5-9.352 9.6-16.233 19.11-16.233h.856c9.51 0 17.61 6.88 19.11 16.233l.834 5.198'/%3E%3Cpath d='M10.124 2.236l.002.01c1.049 5.106 5.603 8.949 11.062 8.949 5.264 0 9.687-3.573 10.936-8.407.047-.18.09-.39.13-.631A1.854 1.854 0 0 0 30.424 0H11.952a1.865 1.865 0 0 0-1.827 2.236z'/%3E%3Cg stroke-linecap='round'%3E%3Cpath d='M14.985 19.676l4.182 7.106m8.064-7.106l-4.183 7.106M14.112 27.487h14.112M21.168 27.487v11.865M14.112 33.419h14.112'/%3E%3C/g%3E%3Cellipse cx='38.122' cy='42.162' rx='9.878' ry='9.838'/%3E%3Cg stroke-linecap='round'%3E%3Cpath d='M38.121 37.243v7.73'/%3E%3Cpath stroke-linejoin='round' d='M33.888 42.865l4.234 4.216 4.233-4.216'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
                          width="100%"
                          height="100%"
                          alt="Cost Reduction"
                      /></i>
                      <span>Cost Reduction</span>
                    </li>
                    <li>
                      <i
                        ><img
                          src="data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h64v64H0z'/%3E%3Cg stroke='%23FFF' stroke-width='2'%3E%3Cpath d='M24.91 29.413h14.18a2.578 2.578 0 0 1 2.578 2.578v7.692a2.577 2.577 0 0 1-2.578 2.577H24.91a2.578 2.578 0 0 1-2.577-2.577V31.99a2.577 2.577 0 0 1 2.577-2.577v-.001z' stroke-linejoin='round'/%3E%3Cpath d='M26.2 29.413v-3.84a3.868 3.868 0 0 1 3.866-3.868h3.868a3.867 3.867 0 0 1 3.867 3.868v3.84'/%3E%3Cpath d='M10 14.806L32 8l22 6.806v12.356C54 40.7 54 48.832 32.003 57 10 48.833 10 40.698 10 27.156v-12.35z' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
                          width="100%"
                          height="100%"
                          alt="Safety Guarantee"
                      /></i>
                      <span>Safety Guarantee</span>
                    </li>
                    <li>
                      <i
                        ><img
                          src="data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' stroke-linecap='round' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cpath d='M23.724 29.252C23.724 18.066 27.594 9 32.367 9c2.344 0 4.47 2.187 6.027 5.738M25.058 38.066C15.403 32.474 9.51 24.578 11.897 20.432c1.172-2.038 4.123-2.79 7.967-2.368M33.334 41.314c-9.656 5.592-19.417 6.764-21.804 2.618-1.172-2.037-.346-4.978 1.94-8.106M40.276 35.748c0 11.186-3.87 20.252-8.643 20.252-2.344 0-4.47-2.187-6.027-5.738M38.942 26.934c9.655 5.592 15.548 13.488 13.161 17.634-1.172 2.038-4.123 2.79-7.967 2.368M30.666 23.686c9.656-5.592 19.417-6.764 21.804-2.618 1.172 2.037.346 4.978-1.94 8.106'/%3E%3C/g%3E%3C/svg%3E"
                          width="100%"
                          height="100%"
                          alt="Extensive Adaptability"
                      /></i>
                      <span>Extensive Adaptability</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="swiper-pagination in-h5"></div>
          </div>
        </div>
      </section>
      <Application
        is-html
        :app-h2="$t('products.3d.area4H2')"
        :app-desc="$t('products.3d.area4Desc')"
        :application-data="applicationData"
      />
      <!-- 轮播 -->
      <div class="vertical-swiper-area">
        <VerticalCarousel
          id="function"
          carousel-h3="Functions"
          :swiper-option="swiperOption"
          :swiper-data="swiperData"
        />
      </div>
      <!-- <videoWrap class="area-5" :video-index="2" :video-info="videoArea5Info" />
      <videoWrap
        class="area-6"
        :video-index="3"
        :video-info="videoArea6Info"
        :wrap-style="{ background: '#FAFAFA', paddingTop: '1.2rem', paddingBottom: '1.6rem' }"
      />
      <section class="area-7 w-12r m-a d-f jc-c">
        <h2 class="in-h5">E-Fence Support</h2>
        <div class="img-box">
          <img
            class="lazy-image"
            src="@/assets/images/3d-excavator/area7.jpg"
            width="100%"
            height="100%"
            alt="E-Fence Support"
          />
        </div>
        <div class="text bgc-fafafa d-f fd-c jc-c">
          <div class="reveal">
            <h2 class="in-pc">E-Fence Support</h2>
            <div class="desc c-666">
              The E-fence function ensures that the excavator arm move within a safety range defined by customized
              height, depth, and farthest distance. <br />
              It allows you to stop automatically once the movable arm exceeds pre-defined area.
            </div>
          </div>
        </div>
      </section> -->
      <videoWrap is-html :video-index="4" :video-info="videoArea8Info" />
      <div class="area-seamless w-12r m-a">
        <Carousel
          ref="seamless"
          :carousel-wrap="{ width: '100%', margin: '0 auto' }"
          :pagination-style="{ top: '5.8rem' }"
          :wrapper-style="{ width: '9.6rem', height: '5.81rem', margin: ' 0 auto 1.2rem auto' }"
          :title="seamlessTitle"
          :swiper-option="seamlessSwiperOption"
          :swiper-data="seamlessSwiperData"
        />
      </div>
      <!-- area-9  -->
      <section class="area-9 bgc-fafafa">
        <div class="w-12r m-a ta-c">
          <h2>2 Different System Configurations</h2>
          <div class="content-box d-f jc-sb">
            <div>
              <a href="/product/excavatorguidance" title="FJD 3D Excavator Guidance System">
                <div class="img-box">
                  <img
                    class="lazy-image"
                    src="@/assets//images/3d-excavator/area9-2.png"
                    width="100%"
                    height="100%"
                    alt="Excavator Guidance System"
                  />
                </div>
              </a>
              <h3>3D Excavator Guidance System</h3>
              <ul>
                <li><span>3cm accuracy</span></li>
                <li><span>3D visual guidance</span></li>
                <li><span>Site design </span></li>
                <li><span>Tilt bucket support </span></li>
              </ul>
            </div>
            <div>
              <a href="/product/fjd-easy-dig-g21-2d-excav" title="FJD 2D Excavator Guidance System">
                <div class="img-box">
                  <img
                    class="lazy-image"
                    src="@/assets/images/3d-excavator/area9-1.png"
                    width="100%"
                    height="100%"
                    alt="Excavator Guidance System"
                  />
                </div>
              </a>
              <h3>2D Excavator Guidance System</h3>
              <ul>
                <li><span>Affordable price</span></li>
                <li><span>Wireless modules</span></li>
                <li><span>Easy to install & calibrate</span></li>
                <li><span>Beginner friendly</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="note ta-r">Note: Please contact our Sales Team for customized solutions.</div>
      </section>
      <section class="area-10 m-a">
        <Carousel
          ref="area10Swiper"
          title="Accessories"
          :carousel-wrap="{ width: '100%', margin: '0 auto' }"
          :pagination-style="{ top: '4.2rem' }"
          :wrapper-style="{ width: '7.44rem', height: '4.2rem', margin: ' 0 auto 1.2rem auto' }"
          :swiper-option="area10SwiperOption"
          :swiper-data="area10SwiperData"
        />
      </section>
      <section class="OTA-area">
        <div class="w-12r h-100p m-a d-f fd-c jc-c">
          <h2 class="fs-48 ta-c c-fff">{{ otaDataTitle }}</h2>
          <ul class="d-f jc-c ta-c">
            <li v-for="(item, index) in otaData" :key="index">
              <i class="d-b">
                <svg-icon :icon-class="item.icon"></svg-icon>
              </i>
              <span class="d-b" v-html="item.desc"></span>
            </li>
          </ul>
        </div>
      </section>
      <!-- 客户案例 -->
      <CustomerCard :customer-data="customerData" />
      <!-- blog -->
      <BlogCard :blog-data="blogData" />
    </div>
  </div>
</template>

<script>
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'
  import bannerImg from '@/assets/images/3d-excavator/banner.jpg'
  import ProductBanner from '@/components/ProductBanner'
  import NavAnchor from '@/components/NavAnchor'
  import IconWrap from '@/components/IconWrap'
  import videoWrap from '@/components/videoWrap'
  import Application from '@/components/Application'
  import CustomerCard from '@/components/CustomerCard'
  import BlogCard from '@/components/BlogCard'
  import VerticalCarousel from '@/components/Carousel/VerticalCarousel'
  import Carousel from '@/components/Carousel/Carousel'
  import bannerScroll from '@/mixins/bannerScroll.js'
  import bannerProductImg from '@/assets/images/3d-excavator/banner-pic.png'

  const verticalTabItem = [
    'products.3d.verticalTab1',
    'products.3d.verticalTab2',
    'products.3d.verticalTab3',
    'products.3d.verticalTab4',
    'products.3d.verticalTab5'
  ]
  const seamlessTabItem = ['Digital Excavation Solution', 'Geospatial & Digital Construction']
  const area10TabItem = ['FJD WiFi Camera', 'FJD Trion V1 Series GNSS Receiver']

  export default {
    components: {
      ProductBanner,
      NavAnchor,
      IconWrap,
      videoWrap,
      Application,
      CustomerCard,
      BlogCard,
      VerticalCarousel,
      Carousel
    },
    mixins: [bannerScroll],
    data() {
      const vm = this
      return {
        bannerImg,
        bannerProductImg,
        iconWrapData: [
          {
            icon: 'visual',
            vHtml: 'products.3d.icon1'
          },
          {
            icon: 'acc-3cm',
            vHtml: 'products.3d.icon2'
          },
          {
            icon: 'tilt-bucket',
            vHtml: 'products.3d.icon3'
          },
          {
            icon: 'remote-control',
            vHtml: 'products.3d.icon4'
          },
          {
            icon: 'e-fence',
            vHtml: 'products.3d.icon5'
          },
          {
            icon: 'ota',
            vHtml: 'products.3d.icon6'
          }
        ],
        videoInfo: {
          h2: 'products.3d.area2H2',
          desc: 'products.3d.area2Desc',
          poster:
            'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/15b28713387702305765099223/sampleSnapshot/sampleSnapshot_10_0.jpg',
          src: 'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/15b28713387702305765099223/aAHSfz7OursA.mp4'
        },
        applicationData: [
          {
            imgUrl: require('@/assets/images/3d-excavator/land-leveling.jpg'),
            imgDesc: 'products.3d.area4Img1'
          },
          {
            imgUrl: require('@/assets/images/3d-excavator/wading-operation.jpg'),
            imgDesc: 'products.3d.area4Img2'
          },
          {
            imgUrl: require('@/assets/images/3d-excavator/deep-excavation.jpg'),
            imgDesc: 'products.3d.area4Img3'
          },
          {
            imgUrl: require('@/assets/images/3d-excavator/slope-cutting.jpg'),
            imgDesc: 'products.3d.area4Img4'
          }
        ],
        swiperOption: {
          el: '',
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'fade',
          autoplay: { delay: 3000 },
          pagination: {
            el: ' .vertical-swiper-style .vertical-swiper-pagination ul',
            clickable: true,
            renderBullet(index, className) {
              return (
                '<li class="' +
                className +
                '"><div class="pagination-item">' +
                vm.$t(verticalTabItem[index]) +
                '</div></li>'
              )
            }
          }
        },
        swiperData: [
          {
            imgSrc: require('@/assets/images/3d-excavator/area-add-1-01.jpg'),
            desc: 'products.3d.verticalTab1Desc'
          },
          {
            imgSrc: require('@/assets/images/3d-excavator/area-add-1-02.jpg'),
            desc: 'products.3d.verticalTab2Desc'
          },
          {
            videoSrc:
              'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/87627368243791576130530137/j2La33vALNsA.mp4',
            poster:
              'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/87627368243791576130530137/sampleSnapshot/sampleSnapshot_10_0.jpg',
            desc: 'products.3d.verticalTab3Desc'
          },
          {
            videoSrc:
              'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/7bdf0f66243791576130054260/NRLVFMxpA50A.mp4',
            poster:
              'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/7bdf0f66243791576130054260/sampleSnapshot/sampleSnapshot_10_0.jpg',
            desc: 'products.3d.verticalTab4Desc'
          },
          {
            videoSrc:
              'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/5279eea2243791576129663697/MYDUjvFfRIcA.mp4',
            poster:
              'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/5279eea2243791576129663697/sampleSnapshot/sampleSnapshot_10_0.jpg',
            desc: 'products.3d.verticalTab5Desc'
          }
        ],
        seamlessTitle: 'Seamless Workflow in One Go',
        seamlessSwiperOption: {
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'slide',
          pagination: {
            el: '.area-8-swiper-tab',
            clickable: true,
            renderBullet(index, className) {
              return '<span style="width:50%" class="' + className + '">' + vm.$t(seamlessTabItem[index]) + '</span>'
            }
          },
          on: {
            init() {
              vm.$refs.seamless.$refs.swiperLine.style.width = `50%`
            },
            slideChange() {
              const index = this.realIndex
              vm.$refs.seamless.$refs.swiperLine.style.transform = `translateX(${index * 100}%)`
            }
          }
        },
        seamlessSwiperData: [
          {
            isHtml: true,
            img: require('@/assets/images/3d-excavator/area-add-2-01.jpg'),
            vHtml:
              '<i></i>Fast connection to each other<br><i></i>Quick site calibration<br><i></i>Network transmission of json files'
          },
          {
            isHtml: true,
            img: require('@/assets/images/3d-excavator/area-add-2-02.jpg'),
            vHtml:
              'FJDynamics machine control system covers a series of construction machineries, such as excavators, motor graders, bulldozers, etc. And combines the geospatial industry to provide professional solutions for various business scenarios.'
          }
        ],
        area10SwiperOption: {
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'slide',
          pagination: {
            el: '.area-8-swiper-tab',
            clickable: true,
            renderBullet(index, className) {
              console.log(vm.$t(area10TabItem[index]))
              return '<span style="width:50%" class="' + className + '">' + vm.$t(area10TabItem[index]) + '</span>'
            }
          },
          on: {
            init() {
              vm.$refs.area10Swiper.$refs.swiperLine.style.width = `50%`
            },
            slideChange() {
              const index = this.realIndex
              vm.$refs.area10Swiper.$refs.swiperLine.style.transform = `translateX(${index * 100}%)`
            }
          }
        },
        area10SwiperData: [
          {
            isHtml: true,
            img: require('@/assets//images/3d-excavator/wifi-camera.png'),
            vHtml: 'Check the real scene around the excavator. Infrared night vision. HD video 1080P. '
          },
          {
            isHtml: true,
            img: require('@/assets/images/3d-excavator/RTK.png'),
            vHtml: 'Deliver accurate positions in harsh environments with global signal coverage.'
          }
        ],
        otaDataTitle: 'Online Service & OTA',
        otaData: [
          {
            icon: 'ota-ico1',
            desc: 'OTA Update'
          },
          {
            icon: 'ota-ico2',
            desc: '24/7 <br>Online Service'
          },
          {
            icon: 'ota-ico3',
            desc: 'Local Support'
          },
          {
            icon: 'ota-ico4',
            desc: '2-Year <br>Warranty'
          }
        ],
        videoArea5Info: {
          h2: 'products.3d.area5H2',
          desc: 'products.3d.area5Desc',
          poster:
            'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/000cc452387702298430153546/sampleSnapshot/sampleSnapshot_10_0.jpg',
          src: 'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/000cc452387702298430153546/Rl2REeBcilQA.mp4'
        },
        videoArea6Info: {
          h2: 'products.3d.area6H2',
          desc: 'products.3d.area6Desc',
          poster:
            'https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/865fd59d387702305953685638/sampleSnapshot/sampleSnapshot_10_0.jpg',
          src: 'https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/865fd59d387702305953685638/n5WJujJnR9wA.mp4'
        },
        videoArea8Info: {
          h2: 'products.3d.area8H2',
          desc: 'products.3d.area8Desc',
          poster: require('@/assets/images/3d-excavator/area8.jpg'),
          src: '',
          isImg: true
        },
        customerData: [
          {
            h2: 'Precise trenching，USA',
            desc: '   "I have equipped the CAT 320 excavator with the 3D excavator grade control system from FJDynamics for my digging channel work in the field. I can monitor and control tasks in real time on the display in the cab. That is great!',
            imgUrl: require('@/assets/images/3d-excavator/area_11_pic1.jpg'),
            videoUrl:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/8cabd39a387702298435663453/3W2yiAfLkV4A.mp4'
          },
          {
            h2: 'Visualized operation, South Korea',
            desc: '    The position of the bucket tooth is accurately displayed on the screen, and the 0 point is perfectly reached. This 3D excavator grade control system is quite easy to use. I think that even inexperienced people can quickly dig accurately.',
            imgUrl: require('@/assets/images/3d-excavator/area_11_pic2.jpg'),
            videoUrl:
              '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/91110900387702298435829365/QrweAETQepYA.mp4'
          },
          {
            h2: 'Unexpected construction accuracy, Bulgaria',
            desc: 'GEOVARA Ltd. has successfully installed FJDynamics excavator grade control system in Varna so that underwater work can be carried out with a real-time accuracy of 1-3 cm.',
            imgUrl: require('@/assets/images/3d-excavator/area_11_pic3.jpg'),
            videoUrl: '//www.youtube.com/embed/rGze6TxUES0'
          }
        ],
        blogData: []
      }
    },
    head() {
      return {
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org/',
              '@type': 'ItemPage',
              '@graph': [
                {
                  '@type': 'Product',
                  name: '3D Excavator Guidance System',
                  url: 'https://www.fjdynamics.com/product/excavatorguidance',
                  image: 'https://www.fjdynamics.com/images/nav0526/nav_wjj.png',
                  description:
                    'FJD 3D excavator guidance system is an excavator 3d grade control system with high construction accuracy.',
                  brand: {
                    '@type': 'Brand',
                    name: 'FJDynamics'
                  },
                  review: [
                    {
                      '@type': 'Review',
                      reviewBody: 'High accuracy and easy to use, fit my Komatsu 700LC excavator perfect',
                      reviewRating: {
                        '@type': 'Rating',
                        ratingValue: '5',
                        bestRating: '5'
                      },
                      author: {
                        '@type': 'Person',
                        name: 'Komatsu 700LC excavator owner'
                      }
                    }
                  ]
                },
                {
                  '@type': 'BreadcrumbList',
                  itemListElement: [
                    {
                      '@type': 'ListItem',
                      position: 1,
                      name: 'Home',
                      item: 'https://www.fjdynamics.com'
                    },
                    {
                      '@type': 'ListItem',
                      position: 2,
                      name: 'Product',
                      item: 'https://www.fjdynamics.com/product'
                    },
                    {
                      '@type': 'ListItem',
                      position: 3,
                      name: '3D Excavator Grade Control Guidance System'
                    }
                  ]
                }
              ]
            }
          }
        ],
        title: '3D EXCAVATOR GUIDANCE SYSTEM',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'excavator grade control, 3d grade control system'
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'FJDynamics 3D excavator GPS grade control system reduces staking process. Using RTK combined with GNSS, positioning accuracy reaches 3cm.'
          }
        ]
      }
    },
    mounted() {
      this.processProductIdBlog()
      // eslint-disable-next-line nuxt/no-env-in-hooks
      if (process.browser) {
        // 滚动混入
        gsap.registerPlugin(ScrollTrigger)

        this.area3Animate()
        this.$nextTick(() => {
          // ;[('video1', 'video2', 'video3', 'video4')].forEach((item) => this.loadVideoPlay(item))
        })
        // this.area4Animate()
      }
    },
    methods: {
      area3Animate() {
        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.area-3',
              start: '45% 50%',
              end: '45% 50%',
              scrub: 1
              // markers: true
            }
          })
          .to('.area3-cont-1', {
            y: '-10%',
            opacity: 0
          })
          .from('.area3-cont-2', {
            y: '10%',
            opacity: 0
          })
      },
      area4Animate() {
        gsap.from('.area-4 li', {
          scrollTrigger: {
            trigger: '.area-4',
            start: '60% 70%',
            end: '60% 70%'
            // markers: true,
          },
          stagger: 0.3,
          duration: 1,
          y: '100%',
          opacity: 0
        })
      },
      async processProductIdBlog() {
        // getProductIdBlog
        const { data } = await this.$api.blogApi.getProductIdBlog({
          languageCode: 'en-US',
          productId: '5'
        })
        this.blogData = data
        console.log('[ data ] >', data)
      },
      loadVideoPlay(el) {
        ScrollTrigger.create({
          trigger: `.${el}`,
          onEnter(self) {
            console.log('[ self ] >', self)

            if (!self.trigger.src) {
              // self.trigger.src = self.trigger.dataset.src
              // const lazyVideoArr = Array.from(document.getElementsByClassName(`${el}`))
              // console.log('[ self ] >', self, lazyVideoArr)
              // document.getElementsByClassName(`${el}`).forEach((element) => {
              //   element.play()
              // })
              // lazyVideoArr.forEach((item, index) => {
              //   // console.log('[ item ] >', item)
              //   // item.play()
              //   document.getElementsByClassName(`${el}`)[index].play()
              // })
              // console.log('[ document.getElementsByClassName()[0] ] >', document.getElementsByClassName(`${el}`)[0])
              // document.getElementsByClassName(`${el}`)[0].play()
            }
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .banner-title {
    margin-bottom: 0.16rem;
    font-size: 0.64rem;
    font-weight: 700;
    line-height: 1.1;
  }
  .banner-title i {
    font-size: 0.48rem;
  }
  .banner-desc {
    font-size: 0.36rem;
    font-weight: 400;
  }
  .content {
    margin-top: 8.76rem;
  }
  .content h2 {
    font-size: 0.48rem;
    color: #333;
    font-weight: 700;
  }
  .area-3 {
    height: 120vh;
    padding-top: 1.6rem;
  }
  .area-3 .sticky {
    position: sticky;
    top: 10%;
  }
  .area-3 h2 {
    margin-bottom: 0.32rem;
  }
  .area3-bg {
    height: 7.32rem;
    width: 100%;
    background-image: url('@/assets/images/3d-excavator/area3-bg.jpg');
    background-size: cover;
    background-position: center;
  }
  .area-3-content-wrap {
    position: relative;
  }
  .area-3-content-wrap > div {
    width: 100%;
    position: absolute;
    top: 1.6rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .area-3-content-wrap .area3-cont-2 {
    top: 2.4rem;
  }
  .area3-bg-desc {
    padding: 0 3.6rem;
    color: #fff;
    text-align: center;
    font-size: 0.32rem;
    font-weight: 500;
  }
  .area3-bg-desc2 {
    margin: 0 0 0.64rem;
    padding: 0 3.6rem;
    color: #fff;
  }
  .labor-hours-warp {
    color: #fff;
    padding: 1.43rem 5.12rem 0;
    display: flex;
    justify-content: space-between;
  }
  .area3-bg-icon ul {
    padding: 0 2.85rem;
  }
  .area3-bg-icon li {
    width: 2.7rem;
    padding: 0.39rem 0;
  }
  .area3-bg-icon li i {
    display: inline-block;
    width: 0.64rem;
    height: 0.64rem;
    margin-bottom: 0.09rem;
  }
  .area3-bg-icon li span {
    display: block;
    font-size: 0.2rem;
    color: #fff;
  }
  :deep(.application .desc-html) {
    width: 70%;
  }
  :deep(.vertical-swiper-style .swiper-wrapper-out) {
    width: 8.96rem;
    height: 5.05rem;
  }
  :deep(.vertical-swiper-style .vertical-swiper-pagination) {
    width: 2.45rem;
    height: 5.05rem;
  }
  :deep(.vertical-swiper-style .swiper-slide) {
    height: 5.05rem;
    background: #fff;
  }
  .arrow-bootom {
    width: 0.17rem;
    height: 0.3rem;
    margin-right: 0.18rem;
  }
  .item-warp {
    border-bottom: 1px solid #fff;
    justify-content: center;
  }
  .num {
    font-size: 0.64rem;
    font-weight: bold;
  }
  .bottom-desc {
    font-size: 0.2rem;
    font-weight: 500;
    margin-top: 0.12rem;
    text-align: center;
  }
  .area-7 {
    background: #fafafa;
    margin-top: 1.6rem;
    margin-bottom: 1.6rem;
  }
  .area-7 .img-box {
    width: 7.44rem;
    height: 4.19rem;
    flex: 0 0 auto;
  }
  .area-7 .text {
    width: 4.56rem;
    height: 4.19rem;
    flex: 0 0 auto;
  }
  .area-7 .text > div {
    margin: 0 0.32rem;
  }
  .area-7 .text h2 {
    margin-bottom: 0.24rem;
  }
  :deep(.area-seamless .swiper-carousel) {
    padding-top: 0;
  }

  :deep(.area-8-swiper .swiper-slide-active div) {
    height: 0.9rem;
  }
  :deep(.area-8-swiper .swiper-slide-active div i) {
    display: inline-block;
    margin-right: 0.1rem;
    width: 0;
    height: 0;
    border: 2px solid #666;
    border-radius: 50%;
    vertical-align: middle;
  }
  // .area9
  /* area-9 */
  .area-9 {
    padding: 1.4rem 0 0.8rem;
  }
  .area-9 h2 {
    padding: 0 0 0.32rem;
  }
  .area-9 .content-box {
    padding-bottom: 1.5rem;
  }
  .area-9 .content-box > div {
    width: 5.16rem;
  }
  .area-9 .content-box .img-box {
    height: 2.91rem;
    margin-bottom: 0.24rem;
    overflow: hidden;
  }
  .area-9 .content-box .img-box img {
    transition: transform 0.3s linear;
  }
  .area-9 .content-box .img-box:hover img {
    transform: scale(1.1);
  }
  .area-9 .content-box h3 {
    font-weight: 500;
    font-size: 0.24rem;
    color: #333;
  }
  .area-9 .content-box ul {
    padding-top: 0.08rem;
    margin-left: 0.95rem;
  }
  .area-9 .content-box li {
    margin-bottom: 0.04rem;
    text-align: left;
    list-style-type: disc;
    list-style-position: inside;
    color: #999;
  }
  .area-9 .content-box li span {
    color: #666;
  }
  .area-9 .note {
    margin-right: 1.2rem;
    color: #bbb;
  }
  /* area-10 */
  .area-10 {
    margin: 0 5.12rem;
  }
  :deep(.area-8-swiper-tab-wrap .line) {
    width: 50%;
  }
  // .area-10 h2 {
  //   margin-bottom: 0.32rem;
  // }
  // .area-10 > div {
  //   margin: 0 5.12rem;
  // }
  // .area-10 .img-wrapper {
  //   width: 7.44rem;
  //   height: 4.2rem;
  //   margin-left: auto;
  //   margin-right: auto;
  //   text-align: center;
  // }

  // .area-10 .swiper-text-wrapper {
  //   height: 0.6rem;
  // }
  // /* 无轮播 */
  // .area-10 .swiper-pagination-wrapper span {
  //   cursor: default;
  //   color: #333;
  //   font-weight: 500;
  //   text-align: center;
  //   display: block;
  //   padding: 0.16rem 0 0.48rem 0;
  //   font-size: 0.28rem;
  // }
  // .area-10 .swiper-pagination-wrapper {
  //   border: none;
  // }
  // .area-10 .swiper-text-wrapper .text {
  //   display: block;
  //   color: #666;
  // }
  // banner
  :deep(.banner-product-img) {
    width: 5.32rem;
    height: 3.7rem;
    // bottom: 0.54rem;
    top: 3.74rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .area-5,
  .area-6 {
    :deep(.video-box) {
      height: 6.75rem;
    }
  }
  .OTA-area {
    height: 6.2rem;
    margin-bottom: 1.6rem;
    background: url('@/assets/images/3d-excavator/area-add-3.jpg');
  }

  .OTA-area h2 {
    color: #fff;
    margin-bottom: 0.64rem;
  }
  .OTA-area li {
    margin: 0 0.84rem;
  }
  .OTA-area li i {
    width: 1.36rem;
    height: 1.36rem;
    margin-bottom: 0.08rem;
  }
  .OTA-area li span {
    font-size: 0.2rem;
    color: #fff;
  }
</style>
